import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientStrengthsResponse } from "@/core/types";

import { getStrengths } from "../queryFunctions/getStrengths";
import { memberCarePlanKeys } from "../keyFactory";

type UseStrengthsProps<TData = PatientStrengthsResponse> = {
  patientId: string;
  select?: (data: PatientStrengthsResponse) => TData;
};

type StrengthsQueryOptions = UseQueryOptions<
  PatientStrengthsResponse,
  unknown,
  PatientStrengthsResponse,
  ReturnType<typeof memberCarePlanKeys.strengths>
>;

export function useStrengths<TData = PatientStrengthsResponse>({
  patientId,
  select,
}: UseStrengthsProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

function optionFactory(patientId: string) {
  return {
    queryFn: () => getStrengths(patientId),
    queryKey: memberCarePlanKeys.strengths(patientId),
  } satisfies StrengthsQueryOptions;
}
